var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 53,
    viewBox: "0 0 50 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 53,
    rx: 25,
    fill: "#959595"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 22.4444C16 19.9898 17.9898 18 20.4444 18H31.5556C34.0102 18 36 19.9898 36 22.4444C36 22.9877 35.6884 23.4829 35.1986 23.718L34.7113 23.9519C32.993 24.7767 32.993 27.2233 34.7113 28.0481L35.1986 28.282C35.6884 28.5171 36 29.0123 36 29.5556C36 32.0102 34.0102 34 31.5556 34H20.4444C17.9898 34 16 32.0102 16 29.5556C16 29.0123 16.3116 28.5171 16.8014 28.282L17.2887 28.0481C19.007 27.2233 19.007 24.7767 17.2887 23.9519L16.8014 23.718C16.3116 23.4829 16 22.9877 16 22.4444Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0175 23.7374C25.3268 22.7542 26.6732 22.7542 26.9825 23.7374C27.1208 24.177 27.5174 24.4747 27.965 24.4747C28.9657 24.4747 29.3818 25.7976 28.5722 26.4052C28.2101 26.6769 28.0586 27.1586 28.1969 27.5983C28.5062 28.5814 27.4168 29.399 26.6072 28.7914C26.2451 28.5196 25.7549 28.5196 25.3928 28.7914C24.5832 29.399 23.4938 28.5814 23.8031 27.5983C23.9414 27.1586 23.7899 26.6769 23.4278 26.4052C22.6182 25.7976 23.0343 24.4747 24.035 24.4747C24.4826 24.4747 24.8792 24.177 25.0175 23.7374Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralTicket);
export default __webpack_public_path__ + "static/media/general-ticket.7737461ef22ea3f64605430288b20cb7.svg";
export { ForwardRef as ReactComponent };